import { render } from "./OptionsInputs.vue?vue&type=template&id=6896b84c&ts=true"
import script from "./OptionsInputs.vue?vue&type=script&lang=ts"
export * from "./OptionsInputs.vue?vue&type=script&lang=ts"

import "./OptionsInputs.vue?vue&type=style&index=0&id=6896b84c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__